import { useContext, useEffect, Suspense } from "react";
import PropTypes from "prop-types";
import componentMap from "@/blades";
import BreadcrumbsNav from "./navigation/Breadcrumbs";
import { BreadcrumbContext } from "./providers/BreadcrumbContext";
import { CacheWrapper } from "./providers/EmotionCacheManager";


function EntityRenderer({ entity }) {

  useEffect(()=>{

    if(entity.type === "product_category_page"){
      setBreadcrumbs([{
        label: 'Products',
        path: '' // no products page... 
      },
      {
        label: entity.title,
        path: window.location.pathname
      }])
      
    } else if(entity.path.includes("about")){

      let crumb = [{
        label: 'About',
        path: '/about'
      }];

      if(entity.path !== "/about"){
        crumb.push({
          label: entity.title,
          path: window.location.pathname
        })
      }

      setBreadcrumbs(crumb)

    }  else if(entity.path.includes("support")){

      let crumb = [{
        label: 'Support',
        path: '/support'
      }];

      if(entity.path !== "/support"){
        crumb.push({
          label: entity.title,
          path: window.location.pathname
        })
      }

      setBreadcrumbs(crumb)

    } else if(entity.path.includes("learn")){

      let crumb = [{
        label: 'Learn',
        path: '/learn'
      }];

      if(entity.path !== "/learn"){
        crumb.push({
          label: entity.title,
          path: window.location.pathname
        })
      }
      
      setBreadcrumbs(crumb)

    } 
    else if(entity.type !== "product_line_page") {
      setBreadcrumbs(null);
    }
    

  }, [])

  const { setBreadcrumbs } = useContext(BreadcrumbContext);

  // filter out any incoming data that we won't be able to render
  // then recursively map entity data to Component props
  // returns a renderable Component tree

  let renderElements = entity.elements
    .filter((el) => {
      if (el.render_name == "title") return false; // dont try to render the builtin title field.
      if (el.render_name == "slug") return false; // dont try to render the builtin slug field.
      return true;
    })
    .map((el) => {
      // substitute unimplemented components
      if (!(el.render_name in componentMap)) {
        console.log("unimplemented component:", el.render_name);
        componentMap[el.render_name] = componentMap.UNIMPLEMENTED;
      }

      // get data from component map
      const Component = componentMap[el.render_name].component;
      const desiredExtracts = [
        "id",
        "value",
        ...componentMap.EXTRACT_ALWAYS,
        ...componentMap[el.render_name].extract,
      ];



      // define the recursive reducer that will flatten and extract data
      const extractReducer = (extracts, current) => {

        // check for matches in nested elements, filters properties we're not interested in
        const r = Object.fromEntries(
          Object.entries(
            Array.isArray(current.value.elements)
              ? current.value.elements.reduce(extractReducer, {})
              : current
          ).filter(([k]) => desiredExtracts.indexOf(k) > -1)
        );

        // add to extracts array if there's a match in desiredExtracts
        // maintain nesting if nested keys are also in desiredExtracts
        if (desiredExtracts.indexOf(current.render_name) > -1) {
          if (current.render_name in extracts) {
            if (Array.isArray(extracts[current.render_name])) {
              // match exists and has items, append item
              return {
                ...extracts,
                [current.render_name]: [...extracts[current.render_name], r],

                // also create an "In Order" copy...
                [`${current.render_name}__${current.id}`]: [extracts[current.render_name]],
              };
            }

            // match exists but only has one item, create array
            return {
              ...extracts,
              [current.render_name]: [extracts[current.render_name], r],
            };
          }

          // match does not yet exist, set to item
          return { ...extracts, [current.render_name]: r, id: current.id || null };
        }

        // no match, don't add anything
        return { ...extracts };
      };

      // do the extraction
      let extracted = {};
      if (el.value.elements) extracted = el.value.elements.reduce(extractReducer, {});

      return (
        <Suspense key={el.id}>
          <CacheWrapper cacheKey="footerCache">
            <Component key={el.id} {...extracted} entity={el} original={el.value.elements} siblings={entity.elements} />
          </CacheWrapper>
        </Suspense>
      )

    });

    if (entity.type !== "product_line_page" && entity.type !== "blog_page") renderElements.splice(1, 0, <BreadcrumbsNav key="breadcrumb"/>);

    return renderElements;
}

EntityRenderer.propTypes = {
  entity: PropTypes.object.isRequired,
};

export default EntityRenderer;
